import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react';

import { acquireAccessToken } from '@/lib/auth/msal';
import { encodeURIObject } from '@/lib/utils/object';
import { RootState } from '@/redux/store';
import {
  CODES_API_URL,
  CODES_API_CLIENT_ID,
  REDIRECT_URL,
  AZURE_CLIENT_ID,
  AZURE_TENANT_ID,
  AZURE_API,
} from '@/lib/env';

async function getHeaders(
  accessToken: string,
  user: string,
  authToken: string
) {
  const headers = new Headers({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${authToken}`,
    'x-client-id': accessToken,
  });

  return headers;
}

const dynamicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  {} /* eslint-disable-line @typescript-eslint/no-empty-object-type */,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  const state = api.getState() as RootState;
  // @ts-ignore
  const { username } =
    state.frontendApi?.queries?.['getV1UsersMe(undefined)']?.data || {};

  const authToken = await acquireAccessToken(
    AZURE_CLIENT_ID,
    AZURE_TENANT_ID,
    REDIRECT_URL,
    AZURE_API
  );

  return fetchBaseQuery({
    baseUrl: CODES_API_URL,
    responseHandler: 'content-type',
    paramsSerializer: encodeURIObject,
    prepareHeaders: () =>
      getHeaders(CODES_API_CLIENT_ID, username, authToken || ''),
  })(args, api, extraOptions);
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const codesApi = createApi({
  reducerPath: 'codesApi',
  // mock Next.js API
  baseQuery: dynamicBaseQuery,
  endpoints: () => ({}),
});
